import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Scrollbars from "react-custom-scrollbars-2";
// import { SidebarData } from "../../data/json/sidebarData";
import ImageWithBasePath from "../imageWithBasePath";
import { useDispatch, useSelector } from "react-redux";
// import { setExpandMenu,setMobileSidebar } from "../../data/redux/commonSlice";
import { setExpandMenu, setMiniSidebar, setMobileSidebar } from "../../../Features/commonSlice";
import { RootState } from '../../../store';

import { all_routes } from "../../../feature-module/router/all_routes";
import ModalComponent from "../modal/ModalComponent";
import { useDirtyState } from "../ConfirmationModaltsx/DirtyStateContext";
import { SidebarData } from "../../data/json/sidebarData";
import { usePermission } from "../../hooks/PermissionHook";
import { constantsPermission } from "../../../Config/Constants";
import { svgIcons } from "../../../style/fonts/SvgIcons";
import { useGetuserProfileQuery } from "../../../services/EndPointsApis";


interface UserDetail {
  firstName: string;
  lastName: string;
}

const Sidebar = () => {
  const Location = useLocation();
  const mobileSidebar = useSelector((state: any) => state.common.mobileSidebar);
  const expandMenu = useSelector((state: any) => state.common.expandMenu);
  const userDetails = useSelector((state: any) => state.auth?.userDetail);
  const userDetails2 = useSelector((state: any) => state.auth?.profileDetails);

  const dispatch = useDispatch();

  const { view, edit, delete: canDelete, create, assign } = usePermission(constantsPermission?.moduleId?.project);

  const [subOpen, setSubopen] = useState("");
  const [subsidebar, setSubsidebar] = useState("");

  const toggleSidebar = (title: any, path: string) => {

    if (title === subOpen) {
      setSubopen("");
    } else {
      setSubopen(title);
    }
    if (isDirty) {
      setCurrentLocation(Location.pathname);  // Save the current location
      setNextPath(path);  // Save the next path for navigation
      setShowModal(true);  //  // Show confirmation modal if there are unsaved changes
    } else {
      navigate(path);  // Navigate directly if no unsaved changes
    }
  };

  const toggleSubsidebar = (subitem: any) => {
    if (subitem === subsidebar) {
      setSubsidebar("");
    } else {
      setSubsidebar(subitem);
    }
  };
  const toggle = () => {
    dispatch(setExpandMenu(expandMenu ? false : true));
  };

  const { isDirty } = useDirtyState();
  const { setIsDirty } = useDirtyState();

  const [showModal, setShowModal] = useState(false);
  const [nextPath, setNextPath] = useState('');
  const [currentLocation, setCurrentLocation] = useState('');

  const navigate = useNavigate();

  const handleLinkClick = (path: string, hasSubmenu: boolean, label: string) => {
    if (isDirty) {
      setCurrentLocation(Location.pathname);  // Save the current location
      setNextPath(path);  // Save the next path for navigation
      setShowModal(true);  //  // Show confirmation modal if there are unsaved changes
    } else {
      navigate(path);  // Navigate directly if no unsaved changes
    }
    // Close sidebar if there's no submenu
    if (!hasSubmenu) {
      dispatch(setMobileSidebar(!mobileSidebar));
      // toggleSidebar(label)
    } else {
    }
  };

  const handleConfirmNavigation = () => {
    setShowModal(false);
    navigate(nextPath);
    setIsDirty(false)
  };

  const handleCancelNavigation = () => {
    setShowModal(false);
    navigate(currentLocation);
  };

  const [isExpanded, setIsExpanded] = useState(false);

  const roles = userDetails?.userAccountInRoles || [];

  const visibleRoles = isExpanded ? roles : roles.slice(0, 1);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };
  const sidebar = SidebarData();
  return (
    <>
      {/* {showModal && (
        <ModalComponent
          buttonText=""
          modalTitle="Unsaved Changes"
          onClose={handleCancelNavigation}
          onSave={handleConfirmNavigation}
          isVisible={showModal}
          cancelButton="Cancel"
          saveButton="Confirm"
        >
          <p>Are you sure you want to leave without saving changes?</p>
        </ModalComponent>
      )} */}
      <div
        className="sidebar"
        id="sidebar"
      // onMouseEnter={toggle}
      // onMouseLeave={toggle}
      >
        <Scrollbars>
          <div className="sidebar-inner slimscroll">
            <div id="sidebar-menu" className="sidebar-menu">
              <ul>
                <li className="clinicdropdown clinicdropdown-user">
                  <Link to="/settings">
                    <img
                      src={userDetails?.imgURL || 'assets/img/profiles/default-upload-img.jpg'}
                      className="img-fluid"
                      alt="Profile"
                      style={{ objectFit: 'cover' }}
                      width={50}
                    />
                    <div className="user-names">
                      {/* <h5>{userDetails?.firstName ?? 'Unknown User'} {userDetails?.lastName}</h5> */}
                      <h5>{userDetails2?.firstName ? userDetails2?.firstName : userDetails?.firstName} {userDetails2?.lastName ? userDetails2?.lastName : userDetails?.lastName}</h5>
                    </div>
                  </Link>
                  {/* <div className="ms-3 d-flex overflow-auto gap-2 align-items-center">
                    <p className="mb-0">{userDetails?.userAccountInRoles?.map((data: any) => {
                      return (
                        <p className="mb-0 d-flex align-items-center gap-1 "><span style={{ fontSize: '24px', color: 'black' }}>•</span>{" "} {data?.roleName}</p>
                      )
                    })}</p>
                  </div> */}
                  <div className="ms-3 d-flex flex-column">
                    <div className="">
                      {visibleRoles.map((data: any, index: number) => (
                        <div
                          key={index}
                          className="d-flex align-items-center gap-1"
                        // style={{ whiteSpace: "nowrap",overflow:'hidden' }}
                        >
                          <span style={{ fontSize: "24px", color: "black" }}>•</span>{" "}
                          {data?.roleName}
                        </div>
                      ))}
                    </div>
                    {roles.length > 1 && (
                      <button
                        onClick={toggleExpand}
                        className="btn btn-link p-0 color-red"
                        style={{ fontSize: "12px", textAlign: 'left' }}
                      >
                        {isExpanded ? "Show Less" : "Show More"}
                      </button>
                    )}
                  </div>
                </li>
              </ul>
              <ul>
                {sidebar?.map((mainLabel: any, index: any) => (
                  <>
                    {mainLabel?.show &&
                      <li className="clinicdropdown" key={index}>
                        <h6 className="submenu-hdr">{mainLabel?.label}</h6>
                        <ul>
                          {mainLabel?.submenuItems?.map((title: any, index: any) => {
                            let link_array: any = [];
                            if ("submenuItems" in title) {
                              title.submenuItems?.map((link: any) => {
                                link_array.push(link?.link);
                                if (link?.submenu && "submenuItems" in link) {
                                  link.submenuItems?.map((item: any) => {
                                    link_array.push(item?.link);
                                  });
                                }
                              });
                            }
                            title.links = link_array;
                            return (
                              <>
                                {title?.show &&
                                  <li className="submenu" key={index}>
                                    <Link
                                      to={title?.link === all_routes.leadsDashboard ? "/jaganb" : title?.link}
                                      onClick={() => {
                                        // handleLinkClick(title.link, !title?.submenu,title?.label);
                                        dispatch(setMobileSidebar(!mobileSidebar));
                                        toggleSidebar(title?.label, title.link);
                                      }}
                                      // onClick={() => toggleSidebar(title?.label)}
                                      className={`${subOpen === title?.label && Location.pathname.includes(title?.label) ? "subdrop active"
                                        : Location.pathname.includes(title?.link)
                                          ? "active"
                                          : ""
                                        }`}
                                    // onClick={() => handleLinkClick(title?.link, !title?.submenuItems)}


                                    //          ${Location.pathname.includes(title?.link)
                                    //           ? "active"
                                    //           : ""
                                    //         }
                                    // `}
                                    // className={`
                                    //   ${subOpen === title?.label || Location.pathname.includes(title?.link) 
                                    //     ? "active" 
                                    //     : ""
                                    //   }
                                    // `}
                                    >
                                      {/* <Grid /> */}
                                      <i className="">{title.icon}</i>
                                      <span>{title?.label}</span>
                                      <span
                                        className={title?.submenu ? "menu-arrow" : ""}
                                      />
                                    </Link>
                                    <ul
                                      style={{
                                        display:
                                          subOpen == title?.label ? "block" : "none",
                                      }}
                                    >
                                      {title?.submenuItems?.map(
                                        (item: any, titleIndex: any) => (
                                          <li
                                            className="submenu submenu-two"
                                            key={titleIndex}
                                          >
                                            {item.lebel}
                                            <Link
                                              to={item?.link}
                                              className={
                                                item?.submenuItems
                                                  ?.map((link: any) => link?.link)
                                                  .includes(Location.pathname) ||
                                                  item?.link == Location.pathname
                                                  ? "active"
                                                  : ""
                                              }
                                              onClick={() => {
                                                toggleSubsidebar(item?.label);
                                                handleLinkClick(title.link, !item?.submenu, item?.label);
                                              }}
                                            >
                                              {item?.label}
                                              <span
                                                className={
                                                  item?.submenu ? "menu-arrow" : ""
                                                }
                                              />
                                            </Link>
                                            <ul
                                              style={{
                                                display:
                                                  subsidebar == item?.label
                                                    ? "block"
                                                    : "none",
                                              }}
                                            >
                                              {item?.submenuItems?.map(
                                                (items: any, titleIndex: any) => (
                                                  <li key={titleIndex}>
                                                    {/* {item.lebel} */}
                                                    <Link
                                                      to={items?.link}
                                                      className={`${subsidebar == items?.label
                                                        ? "submenu-two subdrop"
                                                        : "submenu-two"
                                                        } ${items?.submenuItems
                                                          ?.map(
                                                            (link: any) => link.link
                                                          )
                                                          .includes(
                                                            Location.pathname
                                                          ) ||
                                                          items?.link ==
                                                          Location.pathname
                                                          ? "active"
                                                          : ""
                                                        }`}
                                                    >
                                                      {items?.label}
                                                    </Link>
                                                  </li>
                                                )
                                              )}
                                            </ul>
                                          </li>
                                        )
                                      )}
                                    </ul>
                                  </li>
                                }
                              </>
                            );
                          })}
                        </ul>
                      </li>
                    }
                  </>
                ))}
              </ul>
            </div>
          </div>
        </Scrollbars>
      </div>
    </>
  );
};

export default Sidebar;
